export default "__VITE_ASSET__VVWbSttG__"